import axios from "axios"

const url = process.env.REACT_APP_URL

export const getUserList = async (role, disabled) => {
  role = ['operator', 'admin']
  disabled = [false, true]
  try {
    const data = await axios.get(url + '/users/getUsers', {
      params: { role: role, disabled: disabled }
    })
    return data.data
  } catch (err) {
    console.log(err)
  }
}

export const findUser = async (email: string) => {
  try {
    const data = await axios.get(url + '/user/findUser', {
      params: {
        email: email
      }
    })
    return data.data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const updateUser = async (email: string, firstName: string, lastName: string, role: string, disabled: boolean, id: string) => {
  try {
    const data = await axios.post(url + '/user/updateUser', {
      atlas: email,
      firstName: firstName,
      lastName: lastName,
      role: role,
      disabled: disabled,
      id: id
    })
    return data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const createUser = async (email: string, role: string, firstName: string, lastName: string) => {
  try {
    const data = await axios.post(url + '/user/register', {
      email: email,
      firstname: firstName,
      lastname: lastName,
      role: role
    })
    return data
  } catch (err) {
    console.log(err)
    return err
  }
}